import Yggdrasil from 'services/yggdrasil'
import Vue from 'vue'

import { formatDateToQueryString } from 'components/shared/mixins/dateHelper'
const state = {
    watchLists: [],
    newWatchlistName: null,
    newWatchlistCourse: null,
    newWatchlistCollection: null,
    newWatchlistLearningPath: null,
    modalOpen: false,
    tooltipHelper: {},
    openedMenu: null,
    selectedWatchList: null,
    shareWatchListTeamFilter: null,
    shareWatchListDepartmentFilter: null,
    shareWatchListSelectedSubordinates: [],
    shareWatchListSelectedMembers: [],
    shareWatchListTab: 1,
    subordinates: null,
    shareWatchlistErrorMessage: null,
    isLoadingSubordinates: null,
    type: null
}

const mutations = {
    CLEAR_AFTER_LOGOUT (state) {
        state.watchLists = []
        state.newWatchlistName = null
        state.newWatchlistCourse = null
        state.newWatchlistCollection = null
        state.newWatchlistLearningPath = null
        state.modalOpen = false
        state.tooltipHelper = {}
        state.openedMenu = null
        state.shareWatchListSelectedMembers = []
        state.shareWatchListSelectedSubordinates = []
        state.subordinates = null
        state.selectedWatchList = null
        state.shareWatchListTab = 1
    },
    OPEN_CONTEXT_MENU (state, elementId) {
        state.openedMenu = elementId
    },
    CLOSE_CONTEXT_MENU (state) {
        state.openedMenu = false
    },
    HIGHLIGHT_ELEMENT (state, { currentNewElement, watchlistName }) {
        state.tooltipHelper[currentNewElement] = watchlistName
    },
    UN_HIGHLIGHT_ELEMENT (state, elementId) {
        state.tooltipHelper[elementId] = false
    },
    TOGGLE_MODAL (state, isOpen) {
        state.modalOpen = isOpen
    },
    ASSIGN_NEW_WATCHLIST_COLLECTION (state, id) {
        state.newWatchlistCollection = id
    },
    ASSIGN_NEW_WATCHLIST_COURSE (state, id) {
        state.newWatchlistCourse = id
    },
    ASSIGN_NEW_WATCHLIST_LEARNING_PATH (state, id) {
        state.newWatchlistLearningPath = id
    },
    ASSIGN_NEW_WATCHLIST_NAME (state, name) {
        state.newWatchlistName = name
    },
    ASSIGN_WATCHLIST (state, watchlists) {
        state.watchLists = watchlists
    },
    ASSIGN_SUBORDINATES (state, subordinates) {
        state.subordinates = subordinates
    },
    CREATE_WATCHLIST (state, watchList) {
        state.watchLists.push(watchList)
    },
    UPDATE_WATCHLIST (state, modifiedWatchList) {
        const index = state.watchLists.findIndex(watchList => +watchList.id === +modifiedWatchList.id)
        Vue.set(state.watchLists, index, modifiedWatchList)
    },
    REMOVE_WATCHLIST (state, id) {
        state.watchLists = state.watchLists.filter(watchList => +watchList.id !== +id)
    },
    ASSIGN_SELECTED_WATCHLIST (state, selectedWatchListId) {
        state.selectedWatchList = selectedWatchListId
    },
    SET_SHARE_WATCHLIST_TEAM_FILTER (state, team) {
        state.shareWatchListTeamFilter = team
    },
    SET_SHARE_WATCHLIST_DEPARTMENT_FILTER (state, department) {
        state.shareWatchListDepartmentFilter = department
    },
    SHARE_WATCHLIST_ADD_ALL_SUBORDINATES (state, subordinates) {
        state.shareWatchListSelectedSubordinates = subordinates
    },
    SHARE_WATCHLIST_ADD_OR_REMOVE_SUBORDINATE (state, subordinate) {
        if (state.shareWatchListSelectedSubordinates.find(selectedSubordinate => selectedSubordinate.userId === subordinate.userId)) {
            state.shareWatchListSelectedSubordinates = state.shareWatchListSelectedSubordinates.filter(selectedSubordinate => selectedSubordinate.userId !== subordinate.userId)
        } else {
            state.shareWatchListSelectedSubordinates.push(subordinate)
        }
    },
    SHARE_WATCHLIST_ADD_ALL_MEMBERS (state, members) {
        state.shareWatchListSelectedMembers = members
    },
    SHARE_WATCHLIST_ADD_OR_REMOVE_MEMBER (state, member) {
        if (state.shareWatchListSelectedMembers.find(selectedMember => selectedMember.userId === member.userId)) {
            state.shareWatchListSelectedMembers = state.shareWatchListSelectedMembers.filter(selectedMember => selectedMember.userId !== member.userId)
        } else {
            state.shareWatchListSelectedMembers.push(member)
        }
    },
    SHARE_WATCHLIST_EMPTY_SUBORDINATES (state) {
        state.shareWatchListSelectedSubordinates = []
    },
    SHARE_WATCHLIST_CHANGE_TAB (state, tab) {
        state.shareWatchListTab = tab
    },
    UPDATE_SELECTED_WATCHLIST (state, selectedWatchList) {
        state.selectedWatchList = selectedWatchList
    },
    SET_SHARE_WATCHLIST_ERROR_MESSAGE (state, errorMessage) {
        state.shareWatchlistErrorMessage = errorMessage
    },
    SET_LOADING_SUBORDINATES (state, isLoading) {
        state.isLoadingSubordinates = isLoading
    },
    SET_TYPE (state, type) {
        state.type = type
    }
}

function getWatchlistDetails (watchlist) {
    return {
        title: watchlist.title,
        from: formatDateToQueryString(watchlist.from),
        to: formatDateToQueryString(watchlist.to),
        note: watchlist.note,
        isHidden: watchlist.isHidden
    }
}

const actions = {
    async clearAfterLogout (store) {
        store.commit('CLEAR_AFTER_LOGOUT')
    },
    async loadWatchlists (store) {
        const watchLists = await Yggdrasil.loadWatchLists()
        store.commit('ASSIGN_WATCHLIST', watchLists)
    },
    async loadSubordinates (store) {
        if (store.rootGetters['Menu/getIsReportingAllowed']) {
            store.commit('SET_LOADING_SUBORDINATES', true)
            let subordinates = await Yggdrasil.loadWatchListSubordinates()
            subordinates = subordinates.filter(subordinate => subordinate.userId !== store.rootGetters.getUserId)
            store.commit('ASSIGN_SUBORDINATES', subordinates)
            store.commit('SET_LOADING_SUBORDINATES', false)
        }
    },
    async createWatchList (store, { watchlistDetails, courses = [], collections = [], learningPaths = [] }) {
        const coursesMapped = courses.map(course => +course.id)
        const collectionsMapped = collections.map(collection => +collection.id)
        const learningPathsMapped = learningPaths.map(learningPath => +learningPath.id)
        const addedWatchList = await Yggdrasil.createWatchList(watchlistDetails, coursesMapped, collectionsMapped, learningPathsMapped)
        store.commit('CREATE_WATCHLIST', addedWatchList)
        return Promise.resolve()
    },
    async updateWatchList (store, watchlist) {
        const id = watchlist.id
        const watchlistDetails = getWatchlistDetails(watchlist)
        const coursesMapped = watchlist.courses.map(course => +course.id)
        const collectionsMapped = watchlist.collections.map(collection => +collection.id)
        const learningPathsMapped = watchlist.learningPaths.map(learningPath => +learningPath.id)
        const modifiedWatchList = await Yggdrasil.updateWatchList(id, watchlistDetails, coursesMapped, collectionsMapped, learningPathsMapped)
        store.commit('UPDATE_WATCHLIST', modifiedWatchList)
    },
    async shareWatchList (store, data) {
        await store.dispatch('LoaderScreen/addTaskToLoader', { key: 'shareWatchList', message: 'Sharing Watchlist' }, { root: true })
        switch (data.mode) {
        case 0:
            await Yggdrasil.shareWatchList(data.watchlistId, data.userId, data.mode)
            break
        case 1:
            let subordinateIds = state.shareWatchListSelectedSubordinates.map(subordinate => subordinate.userId)
            let alreadySharedIds = state.selectedWatchList.users.map(subordinate => subordinate.userId)
            subordinateIds = subordinateIds.concat(alreadySharedIds)
            await Yggdrasil.shareWatchList(data.watchlistId, data.userId, data.mode, subordinateIds)
            break
        }
        const watchLists = await Yggdrasil.loadWatchLists()
        store.commit('ASSIGN_WATCHLIST', watchLists)
        const selectedWatchList = watchLists.find(watchlist => watchlist.id === data.watchlistId)
        store.commit('UPDATE_SELECTED_WATCHLIST', selectedWatchList)
        store.dispatch('LoaderScreen/removeTaskFromLoader', 'shareWatchList', { root: true })
    },
    async removeSharingToAllSubordinates (store, data) {
        await store.dispatch('LoaderScreen/addTaskToLoader', { key: 'removeSharing', message: 'Removing sharing from watchlist' }, { root: true })
        await Yggdrasil.shareWatchList(data.watchlistId, data.userId, data.mode, [])
        const watchLists = await Yggdrasil.loadWatchLists()
        store.commit('ASSIGN_WATCHLIST', watchLists)
        const selectedWatchList = watchLists.find(watchlist => watchlist.id === data.watchlistId)
        store.commit('UPDATE_SELECTED_WATCHLIST', selectedWatchList)
        store.dispatch('LoaderScreen/removeTaskFromLoader', 'removeSharing', { root: true })
    },
    async removeSubordinatesFromSharedWatchList (store, data) {
        let updatedSubordinates = state.selectedWatchList.users.filter(user => !state.shareWatchListSelectedMembers.some(item => item.userId === user.userId))
        const subordinateIds = updatedSubordinates.map(subordinate => subordinate.userId)
        await store.dispatch('LoaderScreen/addTaskToLoader', { key: 'removeSharing', message: 'Removing sharing from watchlist' }, { root: true })
        await Yggdrasil.shareWatchList(data.watchlistId, data.userId, data.mode, subordinateIds)
        const watchLists = await Yggdrasil.loadWatchLists()
        store.commit('ASSIGN_WATCHLIST', watchLists)
        const selectedWatchList = watchLists.find(watchlist => watchlist.id === data.watchlistId)
        store.commit('UPDATE_SELECTED_WATCHLIST', selectedWatchList)
        store.dispatch('LoaderScreen/removeTaskFromLoader', 'removeSharing', { root: true })
    },
    async deleteWatchList (store, id) {
        await Yggdrasil.deleteWatchList(id)
        store.commit('REMOVE_WATCHLIST', id)
    },
    async removeCourseFromWatchlist (store, { watchListId, courseId }) {
        const watchlist = store.getters.getWatchlistById(watchListId)

        if (watchlist) {
            watchlist.courses = watchlist.courses.filter(course => course.id !== +courseId)
            return store.dispatch('updateWatchList', watchlist)
        }
        return Promise.reject('watchlist not found')
    },
    async addCourseToWatchlist (store, { watchListId, courseId }) {
        const watchlist = store.getters.getWatchlistById(watchListId)
        if (watchlist) {
            watchlist.courses.push({ id: +courseId })
            return store.dispatch('updateWatchList', watchlist)
        }

        return Promise.reject('watchlist not found')
    },
    async removeCollectionFromWatchlist (store, { watchListId, collectionId }) {
        const watchlist = store.getters.getWatchlistById(watchListId)

        if (watchlist) {
            watchlist.collections = watchlist.collections.filter(collection => collection.id !== +collectionId)
            return store.dispatch('updateWatchList', watchlist)
        }

        return Promise.reject('watchlist not found')
    },
    async removeLearningPathFromWatchlist (store, { watchListId, learningPathId }) {
        const watchlist = store.getters.getWatchlistById(watchListId)

        if (watchlist) {
            watchlist.learningPaths = watchlist.learningPaths.filter(learningPath => learningPath.id !== +learningPathId)
            return store.dispatch('updateWatchList', watchlist)
        }

        return Promise.reject('watchlist not found')
    },
    async addCollectionToWatchlist (store, { watchListId, collectionId }) {
        const watchlist = store.getters.getWatchlistById(watchListId)

        if (watchlist) {
            watchlist.collections.push({ id: +collectionId })
            return store.dispatch('updateWatchList', watchlist)
        }

        return Promise.reject('watchlist not found')
    },
    async addLearningPathToWatchlist (store, { watchListId, learningPathId }) {
        const watchlist = store.getters.getWatchlistById(watchListId)
        if (watchlist) {
            watchlist.learningPaths.push({ id: +learningPathId })
            return store.dispatch('updateWatchList', watchlist)
        }

        return Promise.reject('watchlist not found')
    },
    async assignNewWatchlistName (store, newWatchlistName) {
        let watchlistName = newWatchlistName

        if (newWatchlistName === '') {
            watchlistName = 'new-watch-list' + store.state.watchLists.length
        }

        store.commit('ASSIGN_NEW_WATCHLIST_NAME', watchlistName)
        return Promise.resolve()
    },
    async assignNewWatchlistCourse (store, courseId) {
        store.commit('ASSIGN_NEW_WATCHLIST_COURSE', courseId)
        store.commit('ASSIGN_NEW_WATCHLIST_COLLECTION', null)
        return Promise.resolve()
    },
    async assignNewWatchlistCollection (store, collectionId) {
        store.commit('ASSIGN_NEW_WATCHLIST_COLLECTION', collectionId)
        store.commit('ASSIGN_NEW_WATCHLIST_COURSE', null)
        return Promise.resolve()
    },
    async assignNewWatchlistLearningPath (store, learningPathId) {
        store.commit('ASSIGN_NEW_WATCHLIST_LEARNING_PATH', learningPathId)
        store.commit('ASSIGN_NEW_WATCHLIST_COLLECTION', null)
        store.commit('ASSIGN_NEW_WATCHLIST_COURSE', null)
        return Promise.resolve()
    },
    async assignSelectedWatchList (store, selectedWatchListId) {
        store.commit('ASSIGN_SELECTED_WATCHLIST', selectedWatchListId)
        return Promise.resolve()
    },
    async createNewWatchList (store) {
        const watchlistDetails = {
            title: store.state.newWatchlistName
        }

        let courses = []
        let collections = []
        let learningPaths = []

        await store.dispatch('createWatchList', { watchlistDetails, courses, collections, learningPaths })

        store.commit('ASSIGN_NEW_WATCHLIST_NAME', null)
        store.commit('ASSIGN_NEW_WATCHLIST_COURSE', null)
        store.commit('ASSIGN_NEW_WATCHLIST_COLLECTION', null)
        store.commit('ASSIGN_NEW_WATCHLIST_LEARNING_PATH', null)
        return Promise.resolve()
    },
    async createNewWatchListWithCurrentElement (store) {
        const watchlistDetails = {
            title: store.state.newWatchlistName
        }

        let courses = (store.state.newWatchlistCourse) ? [{ id: store.state.newWatchlistCourse }] : []
        let collections = (store.state.newWatchlistCollection) ? [{ id: store.state.newWatchlistCollection }] : []
        let learningPaths = (store.state.newWatchlistLearningPath) ? [{ id: store.state.newWatchlistLearningPath }] : []

        await store.dispatch('createWatchList', { watchlistDetails, courses, collections, learningPaths })
        if (store.state.newWatchlistCourse) {
            store.commit('HIGHLIGHT_ELEMENT', store.state.newWatchlistCourse)
        }

        store.commit('ASSIGN_NEW_WATCHLIST_NAME', null)
        store.commit('ASSIGN_NEW_WATCHLIST_COURSE', null)
        store.commit('ASSIGN_NEW_WATCHLIST_COLLECTION', null)
        store.commit('ASSIGN_NEW_WATCHLIST_LEARNING_PATH', null)
        return Promise.resolve()
    },
    async toggleModal (store, isOpen) {
        store.commit('TOGGLE_MODAL', isOpen)
    },
    async highlightElement (store, { currentNewElement, watchlistName }) {
        store.commit('HIGHLIGHT_ELEMENT', { currentNewElement, watchlistName })
    },
    async unHighlightElement (store, elementId) {
        store.commit('UN_HIGHLIGHT_ELEMENT', elementId)
    },
    async openMenu (store, elementId) {
        store.commit('OPEN_CONTEXT_MENU', elementId)
    },
    async closeMenu (store) {
        store.commit('CLOSE_CONTEXT_MENU')
    },
    selectTeam (store, team) {
        store.commit('SET_SHARE_WATCHLIST_TEAM_FILTER', team)
    },
    selectDepartment (store, deparment) {
        store.commit('SET_SHARE_WATCHLIST_DEPARTMENT_FILTER', deparment)
    },
    shareWatchListAddAllSubordinates (store, subordinates) {
        store.commit('SHARE_WATCHLIST_ADD_ALL_SUBORDINATES', subordinates)
    },
    shareWatchListAddOrRemoveSubordinate (store, subordinate) {
        store.commit('SHARE_WATCHLIST_ADD_OR_REMOVE_SUBORDINATE', subordinate)
    },
    shareWatchListAddAllMembers (store, members) {
        store.commit('SHARE_WATCHLIST_ADD_ALL_MEMBERS', members)
    },
    shareWatchListAddOrRemoveMember (store, member) {
        store.commit('SHARE_WATCHLIST_ADD_OR_REMOVE_MEMBER', member)
    },
    shareWatchListEmptySubordinates (store) {
        store.commit('SHARE_WATCHLIST_EMPTY_SUBORDINATES')
    },
    shareWatchListChangeTab (store, tab) {
        store.commit('SHARE_WATCHLIST_CHANGE_TAB', tab)
    },
    setShareWatchListErrorMessage (store, message) {
        store.commit('SET_SHARE_WATCHLIST_ERROR_MESSAGE', message)
    },
    setType (store, type) {
        store.commit('SET_TYPE', type)
    }
}
const getters = {
    getCourseSectionForWatchlists: (state) => {
        return state.watchLists.map(watchList => {
            let courses = watchList.courses || []
            return ({
                id: watchList.id,
                title: watchList.title,
                collection: courses.map(({ id }) => +id),
                isReadonly: watchList.isReadonly,
                isShared: watchList.isShared,
                isHidden: watchList.isHidden
            })
        })
    },
    getCollectionSectionForWatchlists: (state) => {
        return state.watchLists.map(watchList => {
            let collections = watchList.collections || []
            return ({
                id: watchList.id,
                title: watchList.title,
                collection: collections.map(({ id }) => id),
                isReadonly: watchList.isReadonly,
                isShared: watchList.isShared,
                isHidden: watchList.isHidden
            })
        })
    },
    getLearningPathSectionForWatchlists: (state) => {
        return state.watchLists.map(watchList => {
            let learningPaths = watchList.learningPaths || []
            return ({
                id: watchList.id,
                title: watchList.title,
                collection: learningPaths.map(({ id }) => id),
                isReadonly: watchList.isReadonly,
                isShared: watchList.isShared,
                isHidden: watchList.isHidden
            })
        })
    },
    getWatchLists: (state) => state.watchLists,
    getWatchlistById: (state) => (watchlistId) => state.watchLists.find(watchlist => +watchlist.id === +watchlistId),
    getNewWatchlistCourse: (state) => state.newWatchlistCourse,
    getNewWatchlistCollection: (state) => state.newWatchlistCollection,
    isModalOpen: (state) => state.modalOpen,
    getToolTipHighlighted: (state) => (elementId) => state.tooltipHelper[elementId],
    getCurrentNewElement: (state, getters) => {
        if (getters.getNewWatchlistCourse) {
            return getters.getNewWatchlistCourse
        }

        if (getters.getNewWatchlistCollection) {
            return getters.getNewWatchlistCollection
        }
        return null
    },
    getCurrentMenuOpened: (state) => state.openedMenu,
    getSelectedWatchList: (state) => state.selectedWatchList,
    getShareWatchListTeamFilter: (state) => state.shareWatchListTeamFilter,
    getShareWatchListDepartmentFilter: (state) => state.shareWatchListDepartmentFilter,
    getShareWatchListSelectedSubordinates: (state) => state.shareWatchListSelectedSubordinates,
    getShareWatchListSelectedMembers: (state) => state.shareWatchListSelectedMembers,
    getShareWatchListTab: (state) => state.shareWatchListTab,
    getSubordinates: (state) => state.subordinates,
    getShareWatchlistErrorMessage: (state) => state.shareWatchlistErrorMessage,
    getIsLoadingSubordinates: (state) => state.isLoadingSubordinates,
    getType: (state) => state.type
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
